'use strict';

exports.__esModule = true;

var _os = require('os');

exports.default = {
  pool: {
    size: (0, _os.cpus)().length
  }
};